// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__GYBZp","faqTitle":"Faq_faqTitle__e+Rh-","faqWrapper":"Faq_faqWrapper__RVJyP"};